/**
 * @param {string | undefined} [className]
 * @param {boolean | undefined} [hovered]
 * @returns {React.ReactElement}
 */
const CompanyLogoNephrocare = ({ className, hovered }) => (
  <svg
    width="275"
    height="60"
    viewBox="0 0 275 60"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_150)">
      <path
        d="M275 51.2065C183.098 33.6924 91.9259 75.8624 0 53.077V45.2065C91.9016 67.9677 183.074 26.1377 274.976 43.6276"
        fill={hovered ? 'url(#paint0_linear_1_150)' : 'currentColor'}
      />
      <path
        d="M25.053 0.583008V24.3401H24.9558L5.66184 0.583008H0V30.3644H4.78705V6.87451H4.88424L24.0567 30.3644H29.6457V0.583008H25.053Z"
        fill={hovered ? '#4389BC' : 'currentColor'}
      />
      <path
        d="M77.0544 11.4171C70.9552 11.4171 68.6224 15.498 68.6224 19.5547C68.6224 23.8057 71.0767 27.7409 77.3217 27.7409C83.5668 27.7409 85.6079 23.6114 85.6079 19.409C85.6079 15.2065 82.935 11.4413 77.0544 11.4413M64.0298 8.81786H68.7682V11.7328H68.8654C70.372 9.35227 73.8955 8.30774 77.6862 8.30774C86.1911 8.30774 90.6137 13.5547 90.6137 19.6519C90.6137 25.749 86.2397 30.8745 77.8077 30.8745C74.989 30.8745 70.9066 30.0486 68.8897 27.498H68.7925V38.6235H64.0541V8.79357L64.0298 8.81786Z"
        fill={hovered ? '#4389BC' : 'currentColor'}
      />
      <path
        d="M94.8904 0.583008H99.4344V11.9757H99.5316C101.038 9.37653 104.926 8.3077 108.231 8.3077C115.497 8.3077 117.732 11.5628 117.732 16.2024V30.3887H113.188V15.7652C113.188 13.1417 111.05 11.417 107.575 11.417C102.083 11.417 99.4101 14.3077 99.4101 18.1701V30.3401H94.8661V0.583008H94.8904Z"
        fill={hovered ? '#4389BC' : 'currentColor'}
      />
      <path
        d="M150.999 27.7409C155.761 27.7409 159.601 24.826 159.601 19.6033C159.601 14.3806 155.761 11.4413 150.999 11.4413C146.236 11.4413 142.396 14.3563 142.396 19.6033C142.396 24.8502 146.236 27.7409 150.999 27.7409M150.999 8.30774C159.746 8.30774 164.412 13.2632 164.412 19.6033C164.412 25.9434 159.771 30.8745 150.999 30.8745C142.226 30.8745 137.585 25.9191 137.585 19.6033C137.585 13.2875 142.226 8.30774 150.999 8.30774"
        fill={hovered ? '#4389BC' : 'currentColor'}
      />
      <path
        d="M122.349 30.3644H126.942V20.8178C126.942 15.3765 129.639 12.1215 137.05 12.1215V8.38059C132.093 8.25913 129.007 9.95953 126.796 13.4089H126.699V8.89071H122.373V30.3644H122.349Z"
        fill={hovered ? '#4389BC' : 'currentColor'}
      />
      <path
        d="M38.8796 17.5628C39.1955 14.2834 42.0629 11.4899 46.8742 11.4899C51.4183 11.4899 54.6987 14.1863 54.9174 17.5628H38.8796V17.5628ZM54.8202 23.5385C54.0183 26.332 51.3697 27.7409 47.5789 27.7409C41.4797 27.7409 38.7095 24.413 38.8796 20.6721H59.7774C60.0447 15.4737 57.0315 8.38062 47.1415 8.38062C39.5357 8.38062 34.0197 13.1175 34.0197 19.5547C34.287 26.1134 38.5151 30.8502 47.4088 30.8502C53.6781 30.8502 58.1007 28.2754 59.34 23.5385H54.7959H54.8202Z"
        fill={hovered ? '#4389BC' : 'currentColor'}
      />
      <path
        d="M199.476 9.78947C198.286 3.44939 192.916 0 184.848 0C172.941 0 167.838 7.04453 167.838 15.668C167.838 23.587 172.066 31.166 184.095 31.166C193.863 31.166 198.893 26.7935 199.865 19.3846H194.714C194.228 24.2915 191.312 27.8381 184.532 27.8381C175.906 27.8381 173.306 22.2996 173.306 15.498C173.306 9.27935 176.562 3.32794 184.799 3.32794C190.17 3.32794 193.231 5.56275 194.325 9.78947H199.476V9.78947Z"
        fill={hovered ? '#0033A0' : 'currentColor'}
      />
      <path
        d="M229.244 27.6195C228.636 27.7895 228.223 27.8381 227.834 27.8381C226.376 27.8381 226.376 27.0851 226.376 25.4332V14.332C226.376 9.30369 220.909 8.4292 215.879 8.4292C209.658 8.4292 204.288 10.2996 203.996 15.6438H208.613C208.808 12.4859 211.699 11.5628 215.587 11.5628C218.503 11.5628 221.808 12.0729 221.808 15.1337C221.808 17.8057 217.458 17.5385 212.38 18.2915C207.617 18.996 202.903 20.0405 202.903 24.9231C202.903 29.1984 207.082 30.9474 212.161 30.9474C216.049 30.9474 219.475 29.9029 222.002 27.6195C222.002 29.9515 223.533 30.9474 225.915 30.9474C227.373 30.9474 228.393 30.7288 229.219 30.3644V27.6195H229.244ZM221.759 22.9555C221.759 24.9231 219.256 27.8381 213.206 27.8381C210.387 27.8381 207.787 26.9879 207.787 24.6802C207.787 22.0567 210.387 21.2308 213.424 20.8179C216.511 20.4049 219.985 20.3563 221.759 19.3604V22.9798V22.9555Z"
        fill={hovered ? '#0033A0' : 'currentColor'}
      />
      <path
        d="M232.767 30.4616H237.384V20.8907C237.384 15.4251 240.106 12.1944 247.517 12.1944V8.42917C242.536 8.30771 239.45 10.0081 237.238 13.4818H237.117V8.93929H232.791V30.4616H232.767Z"
        fill={hovered ? '#0033A0' : 'currentColor'}
      />
      <path
        d="M252.547 17.6114C252.863 14.332 255.755 11.5385 260.566 11.5385C265.11 11.5385 268.415 14.2349 268.634 17.6114H252.547V17.6114ZM268.512 23.6114C267.71 26.4049 265.061 27.8138 261.246 27.8138C255.123 27.8138 252.377 24.4859 252.523 20.7207H273.493C273.761 15.5223 270.723 8.38062 260.809 8.38062C253.179 8.38062 247.639 13.1175 247.639 19.6033C247.906 26.1863 252.134 30.9231 261.076 30.9231C267.37 30.9231 271.792 28.3482 273.056 23.5871H268.512V23.6114Z"
        fill={hovered ? '#0033A0' : 'currentColor'}
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_150"
        x1="0"
        y1="49.6276"
        x2="275"
        y2="49.6276"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.37" stopColor="#4389BC" />
        <stop offset="0.49" stopColor="#3C81B9" />
        <stop offset="0.67" stopColor="#2C6BB2" />
        <stop offset="0.88" stopColor="#1149A7" />
        <stop offset="1" stopColor="#0033A0" />
      </linearGradient>
      <clipPath id="clip0_1_150">
        <rect width="275" height="60" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default CompanyLogoNephrocare;
